import { useAction, useAtom } from '@reatom/npm-react'
import { useState } from 'react'
import styled from 'styled-components'

import { WalletBalanceBadge } from '@root/entities/wallet/ui/desktop'
import {
  setTradingWalletAction,
  tradeSwapTypeAtom,
  tradingWalletAtom,
} from '@root/features/trade/trading'
import { WalletsDialog } from '@root/widgets/desktop/wallets-dialog'

import type { Pair } from '@root/entities/pair'

type Props = {
  pair: Pair.PairMinimal
}

export const TradingControlsWallet: React.FC<Props> = ({ pair }) => {
  const [wallet] = useAtom(tradingWalletAtom)
  const [type] = useAtom(tradeSwapTypeAtom)
  const [walletsOpen, setWalletsOpen] = useState(false)
  const setActiveWallet = useAction(setTradingWalletAction)

  if (!wallet) {
    return undefined
  }

  const currency = type === 'buy' ? pair.base : pair.quote

  return (
    <Root>
      <WalletBalanceBadge
        onClick={() => setWalletsOpen(true)}
        currency={currency}
        wallet={wallet}
      />
      <WalletsDialog
        open={walletsOpen}
        onOpenChange={setWalletsOpen}
        selectedWalletId={wallet.id}
        onWalletSelected={(wallet) => {
          setActiveWallet(wallet.id)
          setWalletsOpen(false)
        }}
        currency={currency}
      />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  justify-content: end;
  align-items: center;
`
